<template>
  <button
    v-if="showButton"
    :class="{
      [$style.buttonBack]: true,
      [$style.buttonBackNewDesign]: isNewDesign,
      [$style.btnAnimation]: true
    }"
    @click.prevent="onBack"
    tabindex="-1"
  >
    <img
      :class="$style.icon"
      src="@/assets/images/icon-back.svg"
      alt="back arrow"
    />
  </button>
</template>

<script>
import store from '@/store'

export default {
  computed: {
    // note: new design
    isNewDesign() {
      return store.getters.hausankerDesign
    },
    showButton() {
      return store.getters['showBackButton']
    }
  },
  methods: {
    onBack() {
      this.$emit('back')
    }
  }
}
</script>

<style lang="scss" module>
@import '@/scss/animations.scss';
@import '@/scss/variables.scss';

.buttonBack {
  user-select: none;
  cursor: pointer;
  display: flex;
  width: 70px;
  height: 100%;
  background-color: $color_bg_light;
  justify-content: center;
  align-items: center;
  outline: none;
  border: 2px $color_grey_4 solid;

  .icon {
    height: 20px;
    width: 24px;
    display: block;
  }
}

.buttonBackNewDesign {
  background: #ffffff;
  border: 2px solid #cecece;
  box-sizing: border-box;
  box-shadow: 0px 1px 4px rgba(38, 40, 37, 0.16),
    0px 6px 12px rgba(38, 40, 37, 0.04);
  border-radius: 6px;
}
</style>
